import { fleetSession } from "../../pages/fleetDriver/fleetDriverApi";
import { Capacitor } from "@capacitor/core";
import { PushNotifications } from "@capacitor/push-notifications";
import { explainPushPermissionOnce } from "./permissionPromptService";
import { getDriverLanguage } from "../../pages/driver/driverI18n";

export async function registerDriverPushToken(registerDriverPushToken) {
  if (fleetSession()) return { status: "company_session" };
  if (!Capacitor.isNativePlatform()) {
    return { status: "web_noop" };
  }

  if (!explainPushPermissionOnce()) {
    return { status: "permission_explanation_declined" };
  }
  const permission = await PushNotifications.requestPermissions();
  if (permission.receive !== "granted") {
    return { status: "permission_denied" };
  }

  return new Promise((resolve) => {
    let settled = false;
    const listeners = [];
    let timer;
    const finish = (result) => {
      if (settled) return;
      settled = true;
      clearTimeout(timer);
      listeners.forEach(handle => handle.remove());
      resolve(result);
    };

    PushNotifications.addListener("registration", async (token) => {
      if (settled || fleetSession()) { finish({status:"session_changed"}); return; }
      try {
        const response = await registerDriverPushToken({
          platform: "ios",
          device_token: token.value,
          fcm_token: token.value,
          enabled: true,
          language: getDriverLanguage(),
        });
        finish({ status: "registered", response });
      } catch (error) {
        finish({ status: "registration_upload_failed", error });
      }
    }).then(handle => settled ? handle.remove() : listeners.push(handle));

    PushNotifications.addListener("registrationError", (error) => {
      finish({ status: "registration_failed", error });
    }).then(handle => settled ? handle.remove() : listeners.push(handle));

    PushNotifications.register().catch(error => finish({status:"registration_failed",error}));
    timer = window.setTimeout(() => finish({ status: "registration_timeout" }), 10000);
  });
}

let actionListener;
export async function initializeDriverPushNotifications(driverApi) {
  if (fleetSession()) return {status:"company_session"};
  if (!driverApi?.registerPushToken) {
    return { status: "missing_api" };
  }
  if (Capacitor.isNativePlatform()) {
    if (actionListener) await actionListener.remove();
    actionListener = await PushNotifications.addListener("notificationActionPerformed", async (event) => {
      if (fleetSession() || event?.notification?.data?.fleet_owner) return;
      const data = event?.notification?.data || {};
      const notificationId = data.notification_id || data.id;
      if (notificationId && driverApi?.markNotificationOpened) {
        try {
          await driverApi.markNotificationOpened(notificationId, {
            order_id: data.order_id,
            opened_order_at: new Date().toISOString(),
          });
        } catch (error) {
          console.warn("[DriverPush] Notification open callback skipped:", error);
        }
      }
      if (data.url && typeof window !== "undefined") {
        window.location.assign(data.url);
      }
    });
  }
  return registerDriverPushToken((payload) => driverApi.registerPushToken(payload));
}
